import SnapshotsFilter from "./SnapshotsFilter";

export default SnapshotsFilter;
